import { Head, usePage } from "@inertiajs/react";
import { BankId } from "@/components/bank-id";
import { useTranslations } from "@/hooks/use-translations";
import AuthLayout from "@/layouts/auth-layout";
import LoginForm from "@/pages/auth/login/login-form";
import { AuthProcess, type SharedData } from "@/types";
import { AuthenticationMethod } from "@/types/authentication-methods";

type LoginProps = {
  authenticationMethods: string[];
  canResetPassword: boolean;
  status?: string;
};

export default function Login({
  status,
  canResetPassword,
  authenticationMethods,
}: LoginProps) {
  const { __ } = useTranslations();
  const { config } = usePage<SharedData>().props;

  return (
    <AuthLayout title={__("auth.log_in_page.layout.title")}>
      <Head title={__("auth.log_in")} />

      {authenticationMethods.includes(AuthenticationMethod.BankId) && (
        <BankId
          authProcess={AuthProcess.LogIn}
          intendedUrl={config.intendedUrl}
        />
      )}

      {authenticationMethods.includes(AuthenticationMethod.EmailPassword) && (
        <LoginForm canResetPassword={canResetPassword} />
      )}

      {status && (
        <div className="mt-4 mb-4 text-center font-medium text-green-600 text-sm">
          {status}
        </div>
      )}
    </AuthLayout>
  );
}
